<app-gabarit-confirmation (systemesEnErreur)="onSystemesEnErreurChange($event)">
  <span class="dsd-t-4" confirmation-titre>
    {{
      (isAjout ? 'confirmation.telephone.titreAjout' : 'confirmation.telephone.titreModification')
        | translate
    }}
  </span>
  <span class="dsd-t-4" confirmation-titre-partiel>
    {{
      (isAjout
        ? 'confirmation.telephone.titreAjoutPartiel'
        : 'confirmation.telephone.titreModificationPartiel'
      ) | translate
    }}
  </span>
  <span confirmation-partiel-contexte>
    {{ 'confirmation.partiel.telephone' | translate }}
  </span>
  <div #steps>
    <p id="dgag">{{ 'confirmation.etapes.rappelDGAG' | translate }}</p>
  </div>
</app-gabarit-confirmation>
